import React from 'react';
import { Edit2, Trash2 } from 'lucide-react';
import SVGColorBlock from './SVGColorBlock';

const SystemCard = ({system, onClick, onEdit, onDelete}) => {
	return (
		<div 
			onClick={onClick} 
			className="group border border-gray-200 dark:border-gray-700 rounded-2xl p-4 cursor-pointer bg-white dark:bg-gray-900 hover:border-[#880e4f] hover:shadow-lg transition-all active:scale-[0.99]"
		>
			<div className="flex justify-between items-start">
				<div className="min-w-0">
					<div className="font-semibold text-lg truncate group-hover:text-[#880e4f] transition-colors">{system.name || 'Untitled System'}</div>
					{system.location && <div className="text-sm text-gray-500 dark:text-gray-400 mt-0.5 truncate">{system.location}</div>}
				</div>
				<div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" onClick={e => e.stopPropagation()}>
					{onEdit && (
						<button onClick={() => onEdit(system)} className="p-1.5 text-gray-400 hover:text-[#880e4f] hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg">
							<Edit2 size={15} />
						</button>
					)}
					{onDelete && (
						<button onClick={() => onDelete(system)} className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-950 rounded-lg">
							<Trash2 size={15} />
						</button>
					)}
				</div>
			</div>
			<div className="mt-3 inline-block text-[10px] font-medium px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400">
				{system.type || 'Default'}
			</div>

			{/* Current colors preview for the system */}
			<div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800 flex items-center justify-between">
				<div className="text-[10px] text-gray-400 dark:text-gray-500">Current</div>
				<SVGColorBlock 
					size={38} 
					data={(system.color || system.colors || []).length ? (system.color || system.colors) : [{r: 80, g: 80, b: 80}]} 
				/>
			</div>
		</div>
	);
}

export default SystemCard;